const roiSimulation = {
  pageName: 'Simulación de ROI',
  subtitle:
    'Compare una ejecución operativa de referencia con una ejecución optimizada por MoveAI y convierta las diferencias en una historia de ROI.',
  controls: {
    title: 'Seleccione ejecuciones para comparar',
    grid: 'Cuadrícula',
    table: 'Tabla',
    filters: {
      baseline: {
        title: 'Ejecución de referencia',
        description: 'Obtiene los KPIs para la fecha seleccionada usando el flujo de trabajo actual del cliente.',
      },
      moveAI: {
        title: 'Ejecución MoveAI',
        description: 'Obtiene los KPIs de la ejecución optimizada, generada por MoveAI para la misma operación.',
      },
      load: 'Cargar',
      loaded: 'Cargado',
    },
  },
  barGraph: {
    title: 'Diferencias Clave (Referencia vs MoveAI)',
    kpisSelected: 'KPIs seleccionados',
    selectKpis: 'Seleccione KPIs para mostrar',
    selected: 'seleccionados',
  },
  kpiComparisons: {
    title: 'Comparaciones de KPI',
    resetKpis: 'Restablecer KPIs',
    showDiffAs: 'Mostrar diferencia como:',
    absolute: 'Absoluto',
    percentage: '%',
  },
  roiInputs: {
    title: 'Entradas de ROI',
    reset: 'Restablecer',
    perMonth: 'por mes',
    tabs: {
      laborSavings: 'Ahorro en mano de obra',
      supplierCosts: 'Costos de proveedores',
      feesHorizon: 'Tarifas y horizonte',
    },
    labor: {
      dispatchersToday: 'Despachadores hoy',
      dispatchersTodayTooltip: 'Número de despachadores actualmente empleados.',
      dispatchersWithMoveAI: 'Despachadores con MoveAI',
      dispatchersWithMoveAITooltip: 'Despachadores estimados necesarios tras MoveAI.',
      costPerDispatcher: 'Costo por despachador',
      hoursPerDay: 'Horas por día',
      workingDaysPerMonth: 'Días laborables por mes',
      currency: 'Moneda',
      savingsTitle: 'Ahorro estimado en despachadores (mensual)',
      savingsDescription: 'Basado en despachadores reducidos × costo por hora × horas/día × días laborables/mes.',
    },
    supplier: {
      costsToday: 'Costos de proveedores hoy (mensual)',
      costsWithMoveAI: 'Costos de proveedores con MoveAI (mensual)',
      savingsTitle: 'Ahorro en proveedores (mensual)',
      savingsDescription: 'Costos de proveedores de referencia menos costos de proveedores de MoveAI.',
      totalSavingsTitle: 'Ahorro total (mensual)',
      totalSavingsDescription: 'Ahorro en mano de obra + proveedores.',
    },
    fees: {
      paymentPlan: 'Plan de pago',
      roiHorizon: 'Horizonte de ROI',
      platformMonthlyFee: 'Tarifa mensual de la plataforma',
      oneTimeImplementationFee: 'Tarifa única de implementación',
      avgBookingsPerMonth: 'Promedio de reservas por mes',
      platformBookingFee: 'Tarifa de reserva de la plataforma',
      totalCostTitle: 'Costo total (horizonte)',
      totalCostDescription: 'Implementación + (tarifas mensuales × horizonte).',
      paybackTitle: 'Tiempo de recuperación',
      paybackDescription: 'Costo total / (ahorro mensual - tarifa mensual).',
      roiTitle: 'ROI',
      roiDescription: 'Beneficio neto en el horizonte / costo total.',
      monthlyFee: 'Tarifa mensual',
      perBookingFee: 'Tarifa por reserva',
    },
    executiveSummary: {
      title: 'Resumen Ejecutivo',
      dispatcherSavings: 'Ahorro estimado en despachadores (mensual)',
      supplierSavings: 'Ahorro en proveedores (mensual)',
      totalSavings: 'Ahorro total (mensual)',
      totalCost: 'Costo total (horizonte)',
      paybackTime: 'Tiempo de recuperación',
      roi: 'ROI',
    },
    suffix: {
      hrs: 'hrs',
      days: 'días',
      day: 'día',
      hr: '/h',
      months: 'meses',
    },
  },
  roiCardsContainer: {
    kpis: {
      totalReservations: 'Total de Reservas',
      assignedReservations: 'Reservas Asignadas',
      unassignedReservations: 'Reservas Sin Asignar',
      sharedRideReservations: 'Reservas Compartidas',
      totalTrips: 'Total de Viajes',
      assignedTrips: 'Viajes Asignados',
      unassignedTrips: 'Viajes Sin Asignar',
      sharedRideTrips: 'Viajes Compartidos',
      driversWithShifts: 'Conductores con Turnos',
      assignedDrivers: 'Conductores Asignados',
      avgTripsPerDriver: 'Prom. Viajes / Conductor',
      avarageBookingsPerDriver: 'Prom. Reservas / Conductor',
      averageTripsDistance: 'Distancia Prom. de Viaje',
      averageTripsDuration: 'Duración Prom. de Viaje',
      averageDeadheadDistance: 'Prom. Recorrido Vacío',
      averageIdleTime: 'Tiempo Inactivo Prom.',
      totalEarnings: 'Ingresos Totales',
      earningPerHour: 'Ingresos por Hora',
      averageTripsEarnings: 'Ingresos Prom. por Viaje',
      averageEarningsPerDriver: 'Ingresos Prom. / Conductor',
      totalCost: 'Costo Total',
    },
    disabled: 'Deshabilitado',
    baseline: 'Referencia',
    moveAI: 'MoveAI',
    noChange: 'Sin Cambios',
    kilometers: 'km',
    minutes: 'min',
    currency: '$',
    k: 'k',
    plus: '+',
    minus: '-',
    percentage: '%',
  },
  tableView: {
    kpiName: 'Nombre del KPI',
    diff: 'Dif.',
    exportTable: 'Exportar Tabla',
    kpis: 'KPIs',
    exportedAt: 'Datos exportados el: {{date}}',
  },
  filters: {
    suppliers: {
      title: 'Proveedor:',
      placeholder: 'Proveedor',
    },
  },
};

export default roiSimulation;
